        
        // animation for sliding text under the product titles
    

function initUniqueCarousel() {
  document.querySelectorAll('.unique-carousel-wrapper').forEach(wrapper => {
    // Prevent double initialization
    if (wrapper.dataset.carouselInitialized) return;
    wrapper.dataset.carouselInitialized = "true";

    const track = wrapper.querySelector('.unique-carousel-track');
    const items = Array.from(track.querySelectorAll('.unique-carousel-item'));
    const pauseDuration = 1500;
    const transitionDuration = 600;

    if (!items.length) return;

    // Clone and append items for infinite scroll
    items.forEach(item => {
      const clone = item.cloneNode(true);
      track.appendChild(clone);
    });

    let currentIndex = 0;

    function animateSlide() {
      currentIndex++;

      const itemHeight = items[0].offsetHeight;
      track.style.transition = `transform ${transitionDuration}ms ease-in-out`;
      track.style.transform = `translateY(-${currentIndex * itemHeight}px)`;

      setTimeout(() => {
        if (currentIndex >= items.length) {
          track.style.transition = 'none';
          currentIndex = 0;
          track.style.transform = 'translateY(0)';
          track.offsetHeight; // Force reflow
        }
        setTimeout(animateSlide, pauseDuration);
      }, transitionDuration);
    }

    setTimeout(animateSlide, pauseDuration);
  });
}

// Run once page is ready
document.addEventListener('DOMContentLoaded', initUniqueCarousel);

// Run when Shopify dynamically loads a section (useful for some themes)
document.addEventListener('shopify:section:load', initUniqueCarousel);
document.addEventListener('shopify:section:reorder', initUniqueCarousel);

// Run when any new product cards are added (AJAX recommendations, etc.)
const observer = new MutationObserver(mutations => {
  for (const mutation of mutations) {
    if (mutation.addedNodes.length > 0) {
      if (document.querySelector('.unique-carousel-wrapper:not([data-carousel-initialized])')) {
        initUniqueCarousel();
      }
    }
  }
});
observer.observe(document.body, { childList: true, subtree: true });
